import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../lib/axios';
import { useAuth } from '../context/AuthContext';

export const AuditLogger: React.FC = () => {
    const location = useLocation();
    const { user } = useAuth();

    useEffect(() => {
        // Visit logging disabled per user request to only count successful logins
        /*
        const logVisit = async () => {
            try {
                await api.post('/audit/log', {
                    path: location.pathname + location.search,
                    userId: user?.id || null
                });
            } catch (err) {
                console.debug('Audit log failed');
            }
        };
        logVisit();
        */
    }, []); 

    return null; // This component doesn't render anything
};
